export default "__VITE_ASSET__DyMxnqKw__"